import SimpleAlert from './SimpleAlert';

export default SimpleAlert;
